import LanguageSupport from '@/docs-partials/optional-settings/language-support.mdx';
import * as React from 'react';
export default {
  LanguageSupport,
  React
};